/* eslint-disable */
import { LibCategories } from "src/utils/consent";
import { loadScript } from "src/utils/scriptLoader";

declare const gtag: any;
declare const dataLayer: any;
declare const window: Window & {
  gtag: any;
  dataLayer: any;
};

window.dataLayer = window.dataLayer || [];
window.gtag = function gtag() {
  dataLayer.push(arguments);
};
gtag("js", new Date());
// Adwords Tag
gtag("config", "AW-783925782");
// Artsai Pixel Tag
gtag("config", "DC-10175718");

// <!-- Google Tag Manager -->
dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });

export function loadGTM() {
  // Unclear if we should be loading both of these or if it's possible to use gtm lib for both.
  // Worth investigating in future.
  return Promise.all([
    // <!-- Global site tag (gtag.js) - Google AdWords: AW-783925782 -->
    loadScript("https://www.googletagmanager.com/gtag/js?id=AW-783925782", [
      LibCategories.strictlyNecessary,
    ]),
    loadScript("https://www.googletagmanager.com/gtm.js?id=GTM-M99GKSM", [
      LibCategories.strictlyNecessary,
    ]),
  ]).then(() => {});
}
